module.exports = __webpack_public_path__ + "static/media/drone-alt.ef9c4ee4.svg";